// extracted by mini-css-extract-plugin
export default {"modal":"faa-z","modalContent":"gaa-z","footer":"haa-z","cancelBtn":"iaa-z","disabled":"jaa-z","formWrapper":"kaa-z","fade":"laa-z","fade-in":"maa-z","iframe":"naa-z"};